import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";
import {PrimeIcons} from "primereact/api";
import {ProgressSpinner} from "primereact/progressspinner";
import ConfigUtil from "../../../../util/ConfigUtil";
import FetchUtil from "../../../../util/FetchUtil";
import {openTournament} from "../../../../containers/views/public/PublicTournamentHelper";
import LoginDialog from "../tournaments/LoginDialog";
import PublicEventOperatorRanglisteTab from "../eventoperator/PublicEventOperatorRanglisteTab";
import LiveBereich from "../tournamentneu/LiveBereich";
import LastEventComp from "../../../LastEventComp";
import ErrorInfoComponent from "../../../general/ErrorInfoComponent";
import SeitenKopf from "../tournamentsneu/SeitenKopf";
import EventListe from "../tournamentsneu/EventListe";
import "../tournamentneu/publicTournamentNeu.css";
import "../tournamentsneu/publicTournamentsNeu.css";

const MIN_SUCHLAENGE = 3;

// die IDs entsprechen den Werten von ?tab= der alten Ansicht, damit bestehende Links weiter funktionieren
const BEREICHE = [
    {id: "events", label: "Events", icon: PrimeIcons.TH_LARGE},
    {id: "tournament_closed", label: "Abgeschlossen", icon: PrimeIcons.CHECK_CIRCLE},
    {id: "ranking", label: "Ranglisten", icon: PrimeIcons.STAR},
    {id: "live", label: "Live", icon: PrimeIcons.EYE},
];

/**
 * Öffentliche Seite eines Veranstalters im neuen Design. Der Bereich steht in der URL (?tab=...).
 */
function PublicEventoperatorNeu({eventOperatorId, isLoggedIn, ranking, appCall}) {

    const [searchParams, setSearchParams] = useSearchParams();
    const bereich = BEREICHE.find(b => b.id === searchParams.get("tab")) || BEREICHE[0];

    const [errorMessage, setErrorMessage] = useState(undefined);
    const [showLoginDialog, setShowLoginDialog] = useState(false);
    const [bezeichnung, setBezeichnung] = useState("");
    const [tournamentsNew, setTournamentsNew] = useState(undefined);
    const [tournamentsOpen, setTournamentsOpen] = useState(undefined);
    const [tournamentsClosed, setTournamentsClosed] = useState(undefined);
    const [suche, setSuche] = useState("");

    useEffect(() => {
        ladeDaten();
    }, [eventOperatorId]);

    const ladeDaten = () => {
        if (eventOperatorId === null || eventOperatorId === undefined) {
            return;
        }
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.public + "/eventoperator/" + eventOperatorId,
            json => {
                setTournamentsNew(json.allTournamentsNew);
                setTournamentsOpen(json.allTournamentsStarted);
                // kommt bereits absteigend nach Beginn sortiert
                setTournamentsClosed(json.allTournamentsClosed);
                setBezeichnung(json.eventoperatorBezeichnung);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden der Daten: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden der Daten: " + error.message);
            });
    }

    const wechsle = (bereichId) => {
        const params = new URLSearchParams(searchParams);
        params.set("tab", bereichId);
        setSearchParams(params);
    }

    // erst ab 3 Zeichen suchen, vorher sind die Treffer nicht aussagekräftig
    const sucheAktiv = suche.trim().length >= MIN_SUCHLAENGE;

    const filter = (tournaments) => {
        const text = suche.trim().toUpperCase();
        if (!sucheAktiv) {
            return tournaments;
        }
        return tournaments.filter(tournament => [tournament.bezeichnung, tournament.austragungsortOrt]
            .some(wert => wert !== null && wert !== undefined && wert.toUpperCase().includes(text)));
    }

    const oeffneEvent = (tournament) => openTournament(tournament, isLoggedIn, () => setShowLoginDialog(true), appCall);

    if (tournamentsOpen === undefined) {
        return <div className="dhpt-seite dhpt-laden">
            <ErrorInfoComponent infoMessage={undefined} errorMessage={errorMessage} onClearInfoMessage={() => ""}
                                onClearErrorMessage={() => setErrorMessage(undefined)}/>
            <ProgressSpinner style={{width: 100, height: 100}}/>
        </div>
    }

    const getSuche = () => {
        return <div className="dhpt-werkzeuge">
            <div className="dhpt-suche dhte-suche-links">
                <i className="pi pi-search dhpt-suche-icon" aria-hidden="true"/>
                <input id="dhte-veranstalter-event-suche" type="search" className="dhpt-suche-feld" placeholder="Event oder Ort …"
                       aria-label="Events des Veranstalters durchsuchen" value={suche} onChange={(e) => setSuche(e.target.value)}/>
            </div>
            {suche.trim().length > 0 && !sucheAktiv && <span className="dhpt-suche-status">Suche ab {MIN_SUCHLAENGE} Zeichen</span>}
        </div>
    }

    const getEventsBereich = () => {
        const laufend = filter(tournamentsOpen);
        const neu = filter(tournamentsNew || []);
        return <>
            {getSuche()}
            <div className="dhpt-inhalt-eigen dhte-abschnitte">
                {laufend.length > 0 &&
                    <section>
                        <h2 className="dhte-abschnitt-titel">Laufende Events</h2>
                        <EventListe tournaments={laufend} onOpen={oeffneEvent}/>
                    </section>
                }
                <section>
                    <h2 className="dhte-abschnitt-titel">Events zur Anmeldung</h2>
                    <EventListe tournaments={neu} onOpen={oeffneEvent}
                                 leerText={!sucheAktiv ? "Aktuell sind keine Events zur Anmeldung offen." : "Keine Events zu deiner Suche gefunden."}/>
                </section>
            </div>
        </>
    }

    const getAbgeschlossenBereich = () => {
        return <>
            {getSuche()}
            <div className="dhpt-inhalt-eigen">
                <EventListe tournaments={filter(tournamentsClosed || [])} onOpen={oeffneEvent}
                             leerText={!sucheAktiv ? "Noch keine abgeschlossenen Events." : "Keine Events zu deiner Suche gefunden."}/>
            </div>
        </>
    }

    const meta = [
        {icon: "pi pi-eye", text: tournamentsOpen.length + " laufend"},
        {icon: "pi pi-plus-circle", text: (tournamentsNew || []).length + " zur Anmeldung"},
        {icon: "pi pi-check-circle", text: (tournamentsClosed || []).length + " abgeschlossen"},
    ];

    return <div className="dhpt-seite">
        <ErrorInfoComponent infoMessage={undefined} errorMessage={errorMessage} onClearInfoMessage={() => ""}
                            onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <SeitenKopf pfad={[{label: bezeichnung}]} appCall={appCall} titel={bezeichnung} meta={meta}
                    chip={<span className="dhpt-chip">Veranstalter</span>}/>
        {!appCall &&
            <div className="dhpt-letzte-events">
                <LastEventComp currentId={""}/>
            </div>
        }

        <nav className="dhpt-nav" role="tablist" aria-label="Bereiche">
            {BEREICHE.map(b => <button key={b.id} type="button" role="tab" aria-selected={b.id === bereich.id}
                                       className="dhpt-nav-button" onClick={() => wechsle(b.id)}>
                <i className={b.icon} aria-hidden="true"/>
                <span>{b.label}</span>
                {b.id === "events" && tournamentsOpen.length > 0 && <span className="dhte-badge">{tournamentsOpen.length}</span>}
            </button>)}
        </nav>

        <main className="dhpt-inhalt darthelfer-background-blue">
            {bereich.id === "events" && getEventsBereich()}
            {bereich.id === "tournament_closed" && getAbgeschlossenBereich()}
            {bereich.id === "ranking" &&
                <div className="dhte-bestand dhpt-bestand"><PublicEventOperatorRanglisteTab eventOperatorId={eventOperatorId} ranking={ranking} appCall={appCall}/></div>
            }
            {bereich.id === "live" &&
                <div className="dhte-bestand dhpt-bestand"><LiveBereich eventOperatorId={eventOperatorId} appCall={appCall} titel={bezeichnung}/></div>
            }
        </main>

        {showLoginDialog &&
            <LoginDialog onClose={() => setShowLoginDialog(false)}/>
        }
    </div>
}

PublicEventoperatorNeu.propTypes = {
    isLoggedIn: PropTypes.bool.isRequired,
    eventOperatorId: PropTypes.string.isRequired,
    ranking: PropTypes.string,
    appCall: PropTypes.bool,
};

export default PublicEventoperatorNeu;
